import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import img1 from '../images/lucky.png'
import img2 from '../images/arrow.png'
import { warmLotteryCache } from '../data/lotteryData'

function Home() {
  useEffect(() => {
    const warm = () => {
      void warmLotteryCache(['powerball', 'mega-millions']);
    };
    const timer = window.setTimeout(warm, 0);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className="wrapperHome">
      <h1>Lotto Club</h1>
      <div className="linkContainer">
        <Link to="/powerball" className="buttonStyle">powerball</Link>
        <Link to="/mega" className="buttonStyle">mega</Link>
      </div>
      <div className='imageContainer'>
      <img src={img2} className="arrow" alt=""></img>
        <Link to="/cover">
          <img src={img1} className="lucky spinAnimation" alt=""></img>
        </Link>
      </div>
    </div>
  )
}

export default Home
